// 卡升级接口地址：http://rap2.10niu.cn/repository/editor?id=21&mod=463&itf=3199

import config from '@/config';
import request from '@/request/request.gateway.js';

export default {
	// 获取设备批次
	getDeviceBatch(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/device_production_plan_items`,
			params
		});
	},
	// 获取返修明细
	getRepairDetail(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/device_repair_order_search`,
			params
		});
	},
	// 获取设备类型列表
	getDeviceTypeList() {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/device_type_items`
		});
	},
	// 获取已存在卡列表
	getCardPresentList(params) {
		return request({
			method: 'get',
			url: `${config.api.admin}/device/v1/card/search_card_number_exist`,
			params
		});
	},
	searchDeviceItemsDetail(params) {
		return request({
			method: 'get',
			url: `${config.api.device}/v1/Device/search-items-detail`,
			params
		});
	}
};
